// src/components/MainTable/SearchBox.tsx
import React from 'react';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

/**
 * Simple text search box (filters name & customer)
 */
const SearchBox: React.FC<Props> = ({ value, onChange }) => (
  <input
    placeholder="Search"
    value={value}
    onChange={e => onChange(e.target.value)}
  />
);

export default SearchBox;
